export const iconFontAwesomeArrowsArrowLeftLong = (
	<i className="fa-solid fa-arrow-left-long"></i>
);
